import DonationDetailsPage from '@/pages/donations/DonationDetailsPage.vue'

const DonationsIndexPage = () => import('@/pages/donations/DonationsIndexPage.vue')

export default [
  { path: "/donations", name: 'DonationsIndexPage', component: DonationsIndexPage },
  { path: "/donations/:donationId", name: 'DonationDetailsPage', component: DonationDetailsPage, props: route => ({ donationId: parseInt(route.params.donationId) }) },
]
